var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSparkles = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkles-sharp",
    clipPath: "url(#clip0_0_2991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.31131 17.9976L5.46982 13.0891L0.561306 11.2476L5.46982 9.40611L7.31131 4.49759L9.15279 9.40611L14.0613 11.2476L9.15279 13.0891L7.31131 17.9976Z",
    fill: "#850064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.09411 6.18523L2.26548 3.92012L0.000360516 3.09148L2.26548 2.26285L3.09411 -0.0022661L3.92274 2.26285L6.18786 3.09148L3.92274 3.92012L3.09411 6.18523Z",
    fill: "#850064"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.061 8.9977L12.9673 6.15392L10.1235 5.0602L12.9673 3.96649L14.061 1.1227L15.1547 3.96649L17.9985 5.0602L15.1547 6.15392L14.061 8.9977Z",
    fill: "#850064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_2991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSparkles);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sparkles.fb358324d2cda5516a50e287d80f9f59.svg";